import React, { Fragment } from "react"
import styled from "@emotion/styled"
import PropTypes from "prop-types"

import { ConcealedValue } from "gatsby-interface"
import {
  Table as BaseTable,
  TableBody,
  TableRow,
  TableHeader,
} from "@modules/ui/components/Table"

const Table = styled(BaseTable)({
  animation: "none",
  transform: "none",
  margin: 0,
  opacity: 1,
})

const KeyCell = styled.td({
  width: `30%`,
  overflow: `hidden`,
  textOverflow: `ellipsis`,
})

const ValueCell = styled.td({
  width: `70%`,
})

export function EnvVarsDisplay({ envVars = [] }) {
  if (!envVars || envVars.length === 0) {
    return null
  }

  return (
    <Table>
      <TableBody>
        <Fragment>
          <TableRow>
            <TableHeader>Key</TableHeader>
            <TableHeader>Value</TableHeader>
          </TableRow>
          {envVars.map(({ key, value }) => (
            <TableRow key={key}>
              <KeyCell data-cy={`env-var-key-` + key}>{key}</KeyCell>
              <ValueCell data-cy={`env-var-value-` + key}>
                <div css={{ display: `inline-block` }}>
                  {value ? (
                    <ConcealedValue value={value} ariaLabel={key} />
                  ) : (
                    <span
                      css={theme => ({
                        color: theme.colors.red[50],
                      })}
                    >
                      PLEASE ENTER A VALUE
                    </span>
                  )}
                </div>
              </ValueCell>
            </TableRow>
          ))}
        </Fragment>
      </TableBody>
    </Table>
  )
}

EnvVarsDisplay.propTypes = {
  envVars: PropTypes.array.isRequired,
}
